import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, Edit2, Trash2 } from 'lucide-react';

export function SortableTimingRow({ id, timing, canEdit, canReorder, onEdit, onDelete }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id, disabled: !canReorder });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style} className="border-b border-stone-100 hover:bg-stone-50">
      <td className="w-8 py-3 px-2">
        {canReorder ? (
          <button {...attributes} {...listeners} className="cursor-grab hover:text-green-700">
            <GripVertical className="h-4 w-4 text-stone-400" />
          </button>
        ) : (
          <span className="text-stone-200">
            <GripVertical className="h-4 w-4" />
          </span>
        )}
      </td>
      <td className="py-3 px-2 font-medium">{timing.schedule_name || timing.schedule_id}</td>
      <td className="py-3 px-2 text-center">{timing.grade_timings?.length || 0}</td>
      <td className="py-3 px-2">
        {canEdit ? (
          <div className="flex items-center justify-center gap-2">
            <button onClick={() => onEdit(timing)} className="action-icon" data-testid={`edit-timing-${timing.timing_id}`}>
              <Edit2 className="h-4 w-4" />
            </button>
            <button onClick={() => onDelete(timing)} className="action-icon" data-testid={`delete-timing-${timing.timing_id}`}>
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ) : (
          <span className="text-xs text-stone-400">-</span>
        )}
      </td>
    </tr>
  );
}
